import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Segment } from 'src/app/core/models/itinerary.model';
import { SelectInput } from 'src/app/core/models/models';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss']
})
export class InputSelectComponent {
  @Input() form: FormGroup;
  @Input() inputName: string;
  @Input() id: string;
  @Input() label: string;
  @Input() value: string | number = '';
  @Input() affectationAvailable: boolean;
  @Input() placeholder: string;
  @Input() errorMessage: string;
  @Input() size: string;
  @Input() submitted: boolean;
  @Input() disabled: boolean;
  @Input() placeholderDisabled = true;
  @Input() noBorder = false;
  @Input() translate = false;
  @Input() values: SelectInput[] | string[] | number[] | Segment[];
  @Input() simple = false;
  @Input() isSegment = false;
  @Input() time = false;

  @Output() changeOption = new EventEmitter<boolean>();

  getControl(): AbstractControl {
    return this.form.get(this.inputName);
  }
}
